import request from '@/api/request'

export function fetchDetectionList(data) {
    return request({
        url: '/model-analysis/diagnose/listDetection',
        method: 'post',
        data,
    })
}
export function fetchDrainPartPageList(data) {
    return request({
        url: '/model-analysis/diagnose/listDrainPartPage',
        method: 'post',
        data,
    })
}
export function fetchFloodPtsPageList(data) {
    return request({
        url: '/model-analysis/diagnose/listFloodPtsPage',
        method: 'post',
        data,
    })
}
export function fetchSewagePageList(data) {
    return request({
        url: '/model-analysis/diagnose/listSewagePage',
        method: 'post',
        data,
    })
}
export function fetchUnderSurfGrnPageList(data) {
    return request({
        url: '/model-analysis/diagnose/listUnderSurfGrnPage',
        method: 'post',
        data,
    })
}
export function fetchWatLvlCtrlPageList(data) {
    return request({
        url: '/model-analysis/diagnose/listWatLvlCtrlPage',
        method: 'post',
        data,
    })
}
export function fetchWatStaPlaPageList(data) {
    return request({
        url: '/model-analysis/diagnose/listWatStaPlaPage',
        method: 'post',
        data,
    })
}
export function fetchWwtPlantOpPageList(data) {
    return request({
        url: '/model-analysis/diagnose/listWwtPlantOpPage',
        method: 'post',
        data,
    })
}
export function selectDetectionNumList() {
    return request({
        url: '/model-analysis/diagnose/selectDetectionNumList',
        method: 'post',
    })
}
export function selectIndexNumList() {
    return request({
        url: '/model-analysis/diagnose/selectIndexNumList',
        method: 'post',
    })
}
export function saveDetection(data) {
    return request({
        url: '/model-analysis/diagnose/saveDetection',
        method: 'post',
        data,
    })
}
export function saveDrainPartPage(data) {
    return request({
        url: '/model-analysis/diagnose/saveDrainPartPage',
        method: 'post',
        data,
    })
}
export function saveFloodPtsPage(data) {
    return request({
        url: '/model-analysis/diagnose/saveFloodPtsPage',
        method: 'post',
        data,
    })
}
export function saveSewagePage(data) {
    return request({
        url: '/model-analysis/diagnose/saveSewagePage',
        method: 'post',
        data,
    })
}
export function saveUnderSurfGrnPage(data) {
    return request({
        url: '/model-analysis/diagnose/saveUnderSurfGrnPage',
        method: 'post',
        data,
    })
}
export function saveWatLvlCtrl(data) {
    return request({
        url: '/model-analysis/diagnose/saveWatLvlCtrl',
        method: 'post',
        data,
    })
}
export function saveWatStaPlaPage(data) {
    return request({
        url: '/model-analysis/diagnose/saveWatStaPlaPage',
        method: 'post',
        data,
    })
}
export function saveWwtPlantOpPage(data) {
    return request({
        url: '/model-analysis/diagnose/saveWwtPlantOpPage',
        method: 'post',
        data,
    })
}
export function modifyDetection(data) {
    return request({
        url: '/model-analysis/diagnose/modifyDetection',
        method: 'post',
        data,
    })
}
export function modifyDrainPartPage(data) {
    return request({
        url: '/model-analysis/diagnose/modifyDrainPartPage',
        method: 'post',
        data,
    })
}
export function modifyFloodPtsPage(data) {
    return request({
        url: '/model-analysis/diagnose/modifyFloodPtsPage',
        method: 'post',
        data,
    })
}
export function modifySewagePage(data) {
    return request({
        url: '/model-analysis/diagnose/modifySewagePage',
        method: 'post',
        data,
    })
}
export function modifyUnderSurfGrnPage(data) {
    return request({
        url: '/model-analysis/diagnose/modifyUnderSurfGrnPage',
        method: 'post',
        data,
    })
}
export function modifyWatLvlCtrl(data) {
    return request({
        url: '/model-analysis/diagnose/modifyWatLvlCtrl',
        method: 'post',
        data,
    })
}
export function modifyWatStaPlaPage(data) {
    return request({
        url: '/model-analysis/diagnose/modifyWatStaPlaPage',
        method: 'post',
        data,
    })
}
export function modifyWwtPlantOpPage(data) {
    return request({
        url: '/model-analysis/diagnose/modifyWwtPlantOpPage',
        method: 'post',
        data,
    })
}
export function remove({ id, type }) {
    return request({
        url: '/model-analysis/diagnose/delete/' + id + '/' + type,
        method: 'post'
    })
}